import { render, staticRenderFns } from "./ManageVehicle.vue?vue&type=template&id=6fa25b3c&scoped=true"
import script from "./ManageVehicle.vue?vue&type=script&lang=js"
export * from "./ManageVehicle.vue?vue&type=script&lang=js"
import style0 from "./ManageVehicle.vue?vue&type=style&index=0&id=6fa25b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa25b3c",
  null
  
)

export default component.exports